import { routes } from '../config/routes';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default function Home() {
  const router = useRouter();
  const navigateTo = router.asPath.split('navigateTo=')[1];

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (navigateTo) {
        navigateTo === '/login' ? router.push(process.env.OMNI_LOGIN) : router.replace(navigateTo as string);
      } else {
        // router.replace(routes.LOGIN.url, '/');
        router.push(process.env.MF_OMNI_ONELINK);
      }
    }
  }, []);
  return null;
}
